import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SortDescendingOutlinedSvg from "@ant-design/icons-svg/es/asn/SortDescendingOutlined";
import AntdIcon from "../components/AntdIcon";
var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SortDescendingOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SortDescendingOutlined.displayName = 'SortDescendingOutlined';
}
export default /*#__PURE__*/React.forwardRef(SortDescendingOutlined);